import { render, staticRenderFns } from "./ContractLongStayDiscountForm.vue?vue&type=template&id=3f62512e&"
import script from "./ContractLongStayDiscountForm.vue?vue&type=script&lang=js&"
export * from "./ContractLongStayDiscountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports